<template>
  <div id="requestAcct" class="acct-info-view jcs-portal-card">
    <div class="container">
      <h1>Account Information</h1>
      <h4>
        ***If you need to change any of your account information, please contact
        one of our reps.
      </h4>

      <div class="row pl-lg-0">
        <div class="col-12">
          <h3 class="mb-3">Change Password?</h3>
          <div
            class="alert alert-danger alert-dismissible"
            v-if="passwordError"
          >
            <button
              type="button"
              class="close"
              data-dismiss="alert"
              @click="passwordError = false"
            >
              &times;
            </button>
            <strong>Warning!</strong> Your new password and confirmation new
            password do not match.
          </div>
        </div>
      </div>

      <form @submit.prevent="userDetailsUpdate">
        <div class="row">
          <div class="col-8 mb-4">
            <label for="password">Current Password</label>
            <input
              v-model="currentPassword"
              type="password"
              id="inputCurrentPassword"
              placeholder="Current Password"
              required
              ref="password"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-4 mb-4">
            <label for="password">New Password</label>
            <input
              v-model="password"
              type="password"
              id="inputPassword"
              placeholder="New Password"
              required
              ref="password"
            />
          </div>
          <div class="col-4 mb-4">
            <label for="confirmPassword">Confirm New Password</label>
            <input
              v-model="confirmPassword"
              type="password"
              id="inputConfirmPassword"
              placeholder="Retype New Password"
              required
              ref="password"
            />
          </div>
        </div>

        <div class="row mb-4">
          <div class="col-12">
            <button type="submit" class="ui btn-primary col-sm-5">
              Change Password
            </button>
          </div>
        </div>
      </form>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>First Name</label>
          <input
            type="text"
            class="form-control"
            name="firstName"
            placeholder="First Name"
            v-model="firstName"
            readonly
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label>Last Name</label>
          <input
            type="text"
            class="form-control"
            name="lastName"
            placeholder="Last Name"
            v-model="lastName"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Title</label>
          <input
            type="text"
            name="title"
            placeholder="title"
            v-model="title"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Email</label>
          <input
            type="email"
            name="email"
            placeholder="email"
            v-model="email"
            class="form-control"
            readonly
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label>Phone Number</label>
          <input
            type="tel"
            name="Phone"
            placeholder="(000) 000-0000"
            v-mask="'(###) ###-####'"
            v-model="phone"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Registered Date</label>
          <input
            type="text"
            name="dateRegistered"
            v-model="dateRegistered"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Address Name</label>
          <input
            type="text"
            name="addressName"
            v-model="address.name"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Address</label>
          <input
            type="text"
            name="address"
            v-model="address.street"
            class="form-control"
            readonly
          />
        </div>

        <div class="col-lg-4 mb-4">
          <label>Address Line 2</label>
          <input
            type="text"
            name="address2"
            v-model="address.street2"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-4 mb-4">
          <label>Address Line 3</label>
          <input
            type="text"
            name="address2"
            v-model="address.street3"
            class="form-control"
            readonly
          />
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2 mb-4">
          <label>City</label>
          <input
            type="text"
            name="city"
            v-model="address.city"
            class="form-control"
            readonly
          />
        </div>

        <div class="col-lg-2 mb-4">
          <label for="State">State</label>
          <input
            type="text"
            name="state"
            v-model="state"
            id="state"
            class="form-control"
            readonly
          />
        </div>

        <div class="col-lg-2 mb-4">
          <label>Postal Code</label>
          <input
            type="text"
            name="postalCode"
            v-model="address.postalCode"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-lg-2 mb-4">
          <label>Country</label>
          <input
            type="text"
            name="country"
            v-model="address.country"
            id="country"
            class="form-control"
            readonly
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import $ from "jquery";
import "expose-loader?$!expose-loader?jQuery!jquery";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "Information",
  computed: {
    ...mapGetters({ currentUser: "currentUser" }),
  },
  created() {
    this.user = this.currentUser;
  },
  mounted() {
    this.getCompanies();
    this.getUserTypes();
    this.getCountries();
    this.getStates();
    this.userDetails();
  },
  data() {
    return {
      user: "",
      companies: [],
      companyList: [],
      id: "",
      customerId: "",
      firstName: "",
      lastName: "",
      title: "",
      email: "",
      phone: "",
      dateRegistered: "",
      active: "",
      roles: [],
      userTypes: [],
      address: [],
      state: "",
      states: [],
      countries: [],
      deleteBtn: false,
      showModal: false,
      currentPassword: "",
      password: "",
      confirmPassword: "",
      passwordError: false,
    };
  },
  methods: {
    companyDropdown() {
      setTimeout(function() {
        $("#companiesSelect.ui.dropdown").dropdown(
          "set selected",
          this.companies
        );
      }, 1500);
    },
    rolesDropdown() {
      setTimeout(function() {
        $("#userTypeSelect").dropdown("set selected", this.roles);
      }, 2000);
    },
    userDetails() {
      apiService
        .getUser({ id: this.user.id })
        .then((request) => {
          this.userDetailsSuccessful(request);

          this.rolesDropdown();
          this.companyDropdown();
        })
        .catch((err) => this.userDetailsFailed(err));
    },
    userDetailsSuccessful(request) {
      (this.companies = request.companies),
        (this.id = request.id),
        (this.customerId = request.customerId),
        (this.firstName = request.firstName),
        (this.lastName = request.lastName),
        (this.title = request.title),
        (this.email = request.email),
        (this.phone = request.phone),
        (this.dateRegistered = request.dateRegistered),
        (this.active = request.active),
        (this.roles = request.roles),
        (this.address = request.address);
    },
    userDetailsFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    userDetailsUpdate() {
      if (this.password != this.confirmPassword) {
        this.passwordError = true;
        $("#inputConfirmPassword").focus();
        // return false;
      } else {
        apiService
          .changePassword({
            currentPassword: this.currentPassword,
            newPassword: this.password,
          })
          // eslint-disable-next-line no-unused-vars
          .then((res) => {
            this.updateSuccessful();
          })
          .catch((err) => {
            this.userDetailsFailed(err)
          });
      }
    },
    deleteModal() {
      this.showModal = !this.showModal;
    },
    updateSuccessful() {
      this.$bvToast.toast("Password has been successfully changed", {
        title: `Success!`,
        variant: "success",
        solid: true,
      });
      setTimeout(() => {
        this.$router.push("/account/index");
      }, 2000);
    },
    getUserTypes() {
      apiService.getUserTypes().then((data) => {
        this.userTypes = data;
      });
    },
    getCompanies() {
      apiService.getCompaniesList().then((data) => {
        this.companyList = data;
      });
    },
    getStates() {
      var states = [];
      apiService.getStatesByCountry("US").then((data) => {
        for (var i = 0; i < data.length; i++) {
          var state = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          states.push(state);
        }
        this.states = states;
      });
    },
    getCountries() {
      var countries = [];
      apiService.getCountries().then((data) => {
        for (var i = 0; i < data.length; i++) {
          var country = {
            key: data[i].code,
            value: data[i].code,
            flag: data[i].code.toLowerCase(),
            text: data[i].name,
          };
          countries.push(country);
        }
        this.countries = countries;
      });
    },
  },
};
</script>
